import moment from 'moment';
import { TFunction } from 'src/constants/i18next';

/**
 * Return the value of the key in the summary of the filters
 *
 * @param {*} value
 * @param {string} key
 * @return {*}
 */
export const summaryRenderValue = (value: any, key: string, t: TFunction) => {
    if (!value) return '';

    const keysWithTranslation = [
        'carType',
        'assignment',
        'score',
        'isContacted',
        'type',
        'isUpdated',
        'isRecordingRated',
        'isRecordingsWithLead',
        'operationType',
    ];

    const dateRangeKeys = [
        'createdAt',
        'closureDate',
        'currentTask',
        'appointmentDate',
        'visitDate',
        'lastTask',
        'firstTask',
        'firstContact',
        'assignedDate',
        'creditBureau.scoreDate',
        'lastUpdate',
        'vehicleDeliveryDate',
        'dateRange',
    ];

    if (Array.isArray(value)) {
        if (
            value.length > 0 &&
            typeof value[0] === 'object' &&
            'label' in value[0]
        ) {
            return value.map((v: any) => v.label).join(', ');
        }
        return value;
    }

    const isTranslationWithValueKey = keysWithTranslation.includes(key);

    const isDateRangeKey = dateRangeKeys.includes(key);

    if (isTranslationWithValueKey)
        return t(`ModalFilters.summaryValues.${key}.${value}`);

    if (isDateRangeKey)
        return (
            moment(value.gte).format('DD MMMM YYYY') +
            ' - ' +
            moment(value.lt).format('DD MMMM YYYY')
        );

    return value;
};
